// Ajout au panier Gonflair : sans recharger la page, puis tiroir du panier ouvert.
// Reprend le contrat d'Horizon (product-form.js) : l'événement CartLinesUpdateEvent porte une promesse
// résolue avec le panier et le HTML des sections du panier, que le tiroir et le compteur de l'en-tête écoutent.
import { CartLinesUpdateEvent } from '@shopify/events';

// le temps de voir partir les cotillons (gonflair-fete.js) avant que le tiroir glisse
const OPEN_DELAY = 450;

/**
 * @param {{ id: number | string, quantity?: number }[]} items
 * @param {HTMLElement} source élément d'origine (l'événement remonte depuis lui)
 * @returns {Promise<boolean>} true si l'ajout a réussi
 */
async function addToCart(items, source) {
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement ? el.dataset.sectionId : '')
    .filter(Boolean);

  // la requête part tout de suite, le tiroir s'ouvre un instant plus tard
  const request = fetch(Theme.routes.cart_add_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: items.map((i) => ({ id: Number(i.id), quantity: i.quantity || 1 })),
      sections: sectionIds.join(','),
    }),
  }).then(async (res) => ({ res, data: await res.json() }));
  request.catch(() => {}); // l’erreur éventuelle est traitée plus bas

  const drawer = document.querySelector('cart-drawer-component');
  const themeDrawer = drawer?.closest('theme-drawer');
  const inModal = source.closest('dialog:modal');
  if (!inModal) await new Promise((resolve) => setTimeout(resolve, OPEN_DELAY));

  // panier vide : le tiroir patiente (« Ajout de votre structure… ») le temps de la réponse
  if (drawer && drawer.querySelector('.cart-drawer--empty')) drawer.setAttribute('data-gf-adding', '');
  if (themeDrawer && !inModal && !themeDrawer.isOpen) {
    themeDrawer.open();
    requestAnimationFrame(() => window.gfFete?.raise());
  }

  const deferred = CartLinesUpdateEvent.createPromise();
  if (drawer?.hasAttribute('data-gf-adding')) {
    // on retire l'attente une fois le tiroir rempli (sinon « Votre panier est vide » clignoterait avant les articles)
    const done = () => {
      observer.disconnect();
      clearTimeout(fallback);
      drawer.removeAttribute('data-gf-adding');
    };
    const observer = new MutationObserver(() => {
      if (!drawer.querySelector('.cart-drawer--empty')) done();
    });
    const fallback = setTimeout(done, 8000);
    observer.observe(drawer, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    deferred.promise.then(({ detail }) => detail?.didError && done(), done);
  }
  source.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity || 1 })),
      promise: deferred.promise,
    })
  );

  try {
    const { res, data } = await request;
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'gonflair',
        itemCount: items.reduce((n, i) => n + (i.quantity || 1), 0),
        sections: data.sections,
        didError: !res.ok,
      },
    });
    return res.ok;
  } catch (error) {
    deferred.reject(error);
    return false;
  }
}

window.gfAddToCart = addToCart;
document.dispatchEvent(new CustomEvent('gf:cart-ready'));
